import _defineProperty from "/var/www/vhosts/unit14.nl/gatsby/unit14.nl/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/var/www/vhosts/unit14.nl/gatsby/unit14.nl/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/var/www/vhosts/unit14.nl/gatsby/unit14.nl/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/var/www/vhosts/unit14.nl/gatsby/unit14.nl/node_modules/@babel/runtime/regenerator/index.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unused-vars */

/* eslint-disable @typescript-eslint/ban-ts-comment */

/* eslint-disable @typescript-eslint/no-explicit-any */

import React from 'react'; // Form

import { Formik, Form } from 'formik'; // Hooks

import useFormDuuf from './useFormDuuf'; // Functions

import schema from './schema';
import defaultValues from './defaultValues'; // Fields

import TextField from './fields/TextField';
import TextAreaField from './fields/TextAreaField';
import ConsentField from './fields/ConsentField';
import FileUploadField from './fields/FileUploadField';
import SelectField from './fields/SelectField';
import MultiSelectField from './fields/MultiSelectField';
import DateField from './fields/DateField';
import SectionField from './fields/SectionField';
import CheckboxField from './fields/CheckboxField';
import RadioField from './fields/RadioField';
import CaptchaField from './fields/CaptchaField';
import NumberField from './fields/NumberField';
import NameField from './fields/NameField';
import AddressField from './fields/AddressField';
import WebsiteField from './fields/WebsiteField';
import ListField from './fields/ListField';
export var FormContext = React.createContext({});
export var FormProvider = FormContext.Provider;
export var FormConsumer = FormContext.Consumer;
export var FormDuuf = function FormDuuf(_ref) {
  var id = _ref.id,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? 'nl' : _ref$language,
      _ref$generate = _ref.generate,
      generate = _ref$generate === void 0 ? true : _ref$generate,
      _ref$scrollToConfirm = _ref.scrollToConfirm,
      scrollToConfirm = _ref$scrollToConfirm === void 0 ? true : _ref$scrollToConfirm,
      _ref$scrollTopOffset = _ref.scrollTopOffset,
      scrollTopOffset = _ref$scrollTopOffset === void 0 ? 0 : _ref$scrollTopOffset,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _children = _ref.children,
      apiUrl = _ref.apiUrl,
      privacyUrl = _ref.privacyUrl,
      privacyUrlPlacement = _ref.privacyUrlPlacement,
      captchaSiteKey = _ref.captchaSiteKey,
      _ref$defaultFields = _ref.defaultFields,
      defaultFields = _ref$defaultFields === void 0 ? {} : _ref$defaultFields,
      renderLoading = _ref.renderLoading,
      renderStatus = _ref.renderStatus,
      _ref$extraTypes = _ref.extraTypes,
      extraTypes = _ref$extraTypes === void 0 ? {} : _ref$extraTypes,
      Loading = _ref.loadingComponent,
      Content = _ref.contentComponent,
      _ref$graphqlData = _ref.graphqlData,
      graphqlData = _ref$graphqlData === void 0 ? {} : _ref$graphqlData,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      _ref$yupSchema = _ref.yupSchema,
      yupSchema = _ref$yupSchema === void 0 ? {} : _ref$yupSchema,
      _ref$yupSchemaOnly = _ref.yupSchemaOnly,
      yupSchemaOnly = _ref$yupSchemaOnly === void 0 ? false : _ref$yupSchemaOnly,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function (values) {
    return null;
  } : _ref$onSubmit,
      _ref$onSubmitDone = _ref.onSubmitDone,
      onSubmitDone = _ref$onSubmitDone === void 0 ? function (values) {
    return null;
  } : _ref$onSubmitDone,
      _ref$errorMessages = _ref.errorMessages,
      errorMessages = _ref$errorMessages === void 0 ? {
    nl: {
      required: 'Is verplicht',
      email: 'E-mailadres niet juist',
      consent: 'U dient akkoord te gaan met de voorwaarden',
      default: 'Er ging iets mis'
    },
    en: {
      required: 'Is required',
      email: 'Is incorrect',
      consent: 'You must agree to the terms',
      default: 'Something went wrong'
    }
  } : _ref$errorMessages;

  var _a, _b, _c;

  var form = null;

  if (Object.keys(graphqlData).length > 0) {
    form = id ? graphqlData.edges.find(function (_ref2) {
      var node = _ref2.node;
      return node.formId === id;
    }) : graphqlData.edges[0];
  }

  if (Object.keys(data).length > 0) {
    form = {
      node: data
    };
  }

  if (!form) {
    return null;
  }

  var formFields = ((_b = (_a = form.node.formFields) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.edges) || ((_c = form.node.formFields) === null || _c === void 0 ? void 0 : _c.nodes) || form.node.formFields;

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      confirmMessage = _React$useState2[0],
      setConfirmMessage = _React$useState2[1];

  var formRef = React.useRef(null);

  var _React$useState3 = React.useState(!captchaSiteKey),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      captchaFilled = _React$useState4[0],
      setCaptchaFilled = _React$useState4[1];

  var executeScrollToConfirm = function executeScrollToConfirm() {
    if (!formRef.current) {
      return;
    }

    window.scrollTo({
      top: formRef.current.offsetTop + scrollTopOffset,
      behavior: 'smooth'
    });
  };

  function parseStringToQueryString(input, values) {
    var regex = /{([^:]+):(\d+)}/g;
    var result = [];
    var match;

    while ((match = regex.exec(input)) !== null) {
      var _match = match,
          _match2 = _slicedToArray(_match, 3),
          key = _match2[1],
          value = _match2[2];

      result.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(values["input_".concat(value)])));
    }

    return result.join('&');
  }

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, values, actions) {
      var formData, request, response, redirect, queryString;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              actions.setSubmitting(true);

              if (onSubmit) {
                onSubmit(values);
              }

              _context.prev = 3;
              formData = new FormData();
              Object.keys(values).forEach(function (key) {
                if (!!values[key] && Array.isArray(values[key])) {
                  values[key].forEach(function (value) {
                    formData.append("".concat(key, "[]"), value);
                  });
                } else {
                  formData.append(key, values[key]);
                }
              });
              _context.next = 8;
              return fetch("".concat(apiUrl ? apiUrl : form.node.apiURL, "/submissions"), {
                method: 'POST',
                body: formData
              });

            case 8:
              request = _context.sent;
              _context.next = 11;
              return request.json();

            case 11:
              response = _context.sent;

              if (response.is_valid === true) {
                setConfirmMessage(response.confirmation_message);
                actions.setStatus('done');
                redirect = form.node.confirmations.find(function (message) {
                  return message.type === 'REDIRECT';
                });

                if (redirect) {
                  queryString = parseStringToQueryString(redirect.queryString, values);
                  window.location.href = "".concat(redirect.url, "?").concat(queryString);
                }

                if (onSubmitDone) {
                  onSubmitDone(values);
                }

                setTimeout(function () {
                  if (scrollToConfirm) {
                    executeScrollToConfirm();
                  }
                }, 100);
              } else {
                actions.setStatus('error');
              }

              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](3);
              actions.setStatus('error');

            case 18:
              actions.setSubmitting(true);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 15]]);
    }));

    return function handleSubmit(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return _jsx("div", {
    className: className,
    ref: formRef,
    children: _jsx(Formik, {
      initialValues: _objectSpread(_objectSpread({}, defaultValues(formFields)), defaultFields),
      onSubmit: function () {
        var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", null);

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onSubmit() {
          return _onSubmit.apply(this, arguments);
        }

        return onSubmit;
      }(),
      validationSchema: schema(formFields, yupSchema, yupSchemaOnly),
      children: function children(formik) {
        if (formik.status === 'done') {
          return _jsx("div", {
            className: "form-duuf-confirm",
            children: renderStatus ? renderStatus({
              status: formik.status,
              content: confirmMessage
            }) : // @ts-ignore
            _jsx(Content, {
              className: "form-duuf-confirm",
              content: confirmMessage
            })
          });
        }

        if (formik.status === 'error') {
          return _jsx("div", {
            className: "form-duuf-something-wrong",
            children: renderStatus ? renderStatus({
              status: formik.status
            }) : // @ts-ignore
            _jsx(Content, {
              className: "form-duuf-something-wrong",
              content: "Er ging iets fout"
            })
          });
        }

        return _jsx(FormProvider, {
          value: {
            language: language,
            fields: formFields,
            formik: formik,
            form: form.node,
            privacyUrl: privacyUrl,
            privacyUrlPlacement: privacyUrlPlacement,
            captchaSiteKey: captchaSiteKey,
            captchaFilled: captchaFilled,
            setCaptchaFilled: setCaptchaFilled,
            reset: formik.handleReset,
            extraTypes: extraTypes,
            errorMessages: errorMessages
          },
          children: _jsxs(Form, {
            id: "form_".concat(form.node.formId),
            // @ts-ignore
            onSubmit: function onSubmit(event) {
              return handleSubmit(event, formik.values, formik);
            },
            method: "post",
            children: [formik.isSubmitting && _jsx("div", {
              className: "form-duuf-loading",
              children: renderLoading ? renderLoading() : _jsx(Loading, {})
            }), generate ? _jsxs(_Fragment, {
              children: [_jsx(FormDuufGroup, {}), _jsx(FormDuufSubmit, {})]
            }) : _children]
          })
        });
      }
    })
  });
};
export var FormDuufGroup = function FormDuufGroup(_ref4) {
  var _ref4$showIds = _ref4.showIds,
      showIds = _ref4$showIds === void 0 ? [] : _ref4$showIds,
      _ref4$hideIds = _ref4.hideIds,
      hideIds = _ref4$hideIds === void 0 ? [] : _ref4$hideIds;
  var context = useFormDuuf();
  var fields = context.fields.filter(function (field) {
    if (showIds.length > 0 && showIds.indexOf(Number(field.id)) === -1) {
      return false;
    }

    if (hideIds.length > 0 && hideIds.indexOf(Number(field.id)) !== -1) {
      return false;
    }

    return true;
  });
  return _jsx(_Fragment, {
    children: fields === null || fields === void 0 ? void 0 : fields.filter(function (field) {
      var _a;

      return ((_a = field === null || field === void 0 ? void 0 : field.visibility) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== 'hidden';
    }).map(function (field) {
      return _jsx(FormDuufField, {
        id: Number(field === null || field === void 0 ? void 0 : field.id)
      }, field === null || field === void 0 ? void 0 : field.id);
    })
  });
};
export var FormDuufField = function FormDuufField(_ref5) {
  var id = _ref5.id;

  var _a;

  var context = useFormDuuf();
  var field = prepareFormDuufField(id);

  if (!field.data) {
    return null;
  }

  var types = _objectSpread(_objectSpread({}, {
    list: ListField,
    website: WebsiteField,
    address: AddressField,
    name: NameField,
    number: NumberField,
    text: TextField,
    email: TextField,
    phone: TextField,
    textarea: TextAreaField,
    consent: ConsentField,
    select: SelectField,
    multiselect: MultiSelectField,
    fileupload: FileUploadField,
    date: DateField,
    section: SectionField,
    checkbox: CheckboxField,
    radio: RadioField,
    captcha: CaptchaField
  }), context.extraTypes);

  var type = (_a = field.data.type) === null || _a === void 0 ? void 0 : _a.toLowerCase(); // @ts-ignore

  if (!types[type]) {
    return null;
  } // @ts-ignore


  var Component = types[type];
  return _jsx(Component, {
    hasError: field.hasError,
    formik: context.formik,
    fieldId: field.fieldId,
    data: field.data
  });
};
export var prepareFormDuufField = function prepareFormDuufField(id) {
  var context = useFormDuuf();
  var data = context.fields.find(function (field) {
    return Number(field.id) === id;
  });

  if (!data) {
    return {
      data: {},
      hasError: true,
      fieldId: ''
    };
  }

  var fieldId = "input_".concat(data.id);
  var meta = context.formik.getFieldMeta(fieldId);
  var hasError = meta.error && meta.touched;
  return {
    data: data,
    hasError: hasError,
    fieldId: fieldId,
    meta: meta
  };
};
export var FormDuufSubmit = function FormDuufSubmit() {
  var context = useFormDuuf();
  var isValid = context.captchaFilled && context.formik.isSubmitting === false && Object.keys(context.formik.touched).length > 0 && Object.keys(context.formik.errors).length === 0;
  return _jsx("div", {
    className: "form-duuf-group form-duuf-group-submit",
    children: _jsx("span", {
      className: "form-duuf-submit".concat(!isValid ? ' form-duuf-submit-disabled' : ''),
      children: _jsx("button", {
        type: "submit",
        disabled: !isValid,
        children: context.form.button.text
      })
    })
  });
};
export default FormDuuf;